export enum ConnectionPhase {
  Idle = "idle",

  Connecting = "connecting",

  Connected = "connected",

  Streaming = "streaming",

  Reconnecting = "reconnecting",

  Disconnected = "disconnected",

  Error = "error",
}

export function isActivePhase(phase: ConnectionPhase): boolean {
  return (
    phase === ConnectionPhase.Connected || phase === ConnectionPhase.Streaming
  );
}

export const CONNECTION_PHASE_LABELS: Record<ConnectionPhase, string> = {
  [ConnectionPhase.Idle]: "Idle",

  [ConnectionPhase.Connecting]: "Connecting...",

  [ConnectionPhase.Connected]: "Connected",

  [ConnectionPhase.Streaming]: "Streaming",

  [ConnectionPhase.Reconnecting]: "Reconnecting...",

  [ConnectionPhase.Disconnected]: "Disconnected",

  [ConnectionPhase.Error]: "Error",
};

export type ChatMessageStatus = "sending" | "sent" | "failed";

export interface ChatMessage {
  /** Server-assigned canonical id. `null` while the POST is in-flight. */
  id: string | null;

  /** Server-assigned monotonically increasing sequence. `null` while in-flight. */
  seq: number | null;

  /** Local id used to reconcile a pending message with its server response. */
  localId?: string;

  text: string;

  isMe: boolean;

  timestamp: number;

  sender?: string;

  status?: ChatMessageStatus;
}
